"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

var _Search = _interopRequireDefault(require("../../Search/Search"));

var _GlobalRowFilter = require("./GlobalRowFilter.styles");

// Implements global row filtering
var GlobalRowFilter = function GlobalRowFilter(_ref) {
  var globalFilter = _ref.globalFilter,
      setGlobalFilter = _ref.setGlobalFilter,
      className = _ref.className,
      searchPlaceholder = _ref.searchPlaceholder,
      disabled = _ref.disabled,
      disabledHint = _ref.disabledHint;

  var _useState = (0, _react.useState)(globalFilter),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = (0, _react.useCallback)(function (term) {
    setGlobalFilter(term || undefined);
  }, [setGlobalFilter]);
  var handleSearch = (0, _react.useCallback)(function (e) {
    setValue(e.target.value);
    onChange(e.target.value);
  }, [onChange]);
  return (0, _jsxRuntime.jsx)(_Tooltip["default"], {
    title: disabled ? disabledHint : undefined,
    position: "top-end",
    maxWidth: 300,
    children: (0, _jsxRuntime.jsx)("span", {
      children: (0, _jsxRuntime.jsx)(_Search["default"], {
        name: "search",
        placeholder: "Search ".concat(searchPlaceholder, "..."),
        css: _GlobalRowFilter.styles.base,
        onChange: handleSearch,
        value: value || '',
        className: className,
        disabled: disabled
      })
    })
  });
};

GlobalRowFilter.propTypes = {
  className: _propTypes.string,
  searchPlaceholder: _propTypes.string,

  /**
   * https://react-table.tanstack.com/docs/api/useGlobalFilter
   * setGlobalFilter and globalFilter are properties returned by useTable
   */
  setGlobalFilter: _propTypes.func,
  globalFilter: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  disabled: _propTypes.bool,
  disabledHint: _propTypes.string
};
GlobalRowFilter.defaultProps = {
  className: undefined,
  searchPlaceholder: '',
  setGlobalFilter: function setGlobalFilter() {},
  globalFilter: undefined,
  disabled: false,
  disabledHint: undefined
};
var _default = GlobalRowFilter;
exports["default"] = _default;
//# sourceMappingURL=GlobalRowFilter.js.map